import * as Yup from 'yup';

import { requireEmailValidation } from 'helpers/validate';

export const formTrainerSchema = Yup.object().shape({
  email: requireEmailValidation,
  firstName: Yup.string().min(1).required(),
  gender: Yup.string().required(),
  phone: Yup.string().required(),
  level: Yup.string().required(),
  institutionId: Yup.string(),
});

export const formUpdateTrainerSchema = Yup.object().shape({
  email: requireEmailValidation,
  firstName: Yup.string().min(1).required(),
  gender: Yup.string().required(),
  phone: Yup.string().required(),
  level: Yup.string().required(),
  password: Yup.string().min(6),
});
